/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description navbar selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

const selectNavbar = (state: State) => state.navbar

export const selectMobileViewType = compose((state) => state.mobileViewType, selectNavbar)

export const selectIsNavbarSticky = compose((state) => state.isNavbarSticky, selectNavbar)
